import { useState } from "react";
import SvgIcon from "../../../../parts/SvgIcon";
import { formatNumber } from "../../../../utils/format-sub";
import BandTag from "./BandTag";

const TopPlansTable = ({
  plans = [],
  currency = "usd",
  showProduct = false,
  t,
}) => {
  const money = (value) => formatNumber(value || 0, currency);
  const planPrice = (plan) =>
    plan.interval && plan.amount != null
      ? `${money(plan.amount)}/${t(`income.plans.interval.${plan.interval}`, {
          count: plan.intervalCount || 1,
        })}`
      : null;
  const [sortDirection, setSortDirection] = useState(null);
  const sortedPlans = sortDirection
    ? [...plans].sort((a, b) => {
        const cmp = (a.planName || "").localeCompare(b.planName || "");
        return sortDirection === "asc" ? cmp : -cmp;
      })
    : plans;

  return (
    <>
      <header className="table-card__header">
        <h3>{t("income.topPlans.title")}</h3>
        <BandTag kind="period" label={t("income.bands.period")} />
      </header>
      {/* biome-ignore lint/a11y/useValidAriaRole: report-table used for structure */}
      <table role="report-table">
        <thead>
          <tr>
            {showProduct && <th>{t("income.plans.product")}</th>}
            <th>
              <div className="flex gap-2 items-center justify-center">
                {t("income.plans.plan")}
                <SvgIcon
                  src="/img/svg/up_down_arrows.svg"
                  onClickFn={() =>
                    setSortDirection((prev) =>
                      prev === "asc" ? "desc" : "asc"
                    )
                  }
                />
              </div>
            </th>
            <th>{t("income.plans.revenue")}</th>
            <th>{t("income.topPlans.share")}</th>
          </tr>
        </thead>
        <tbody>
          {sortedPlans.map((plan) => (
            <tr key={plan.priceId || plan.planName}>
              {showProduct && (
                <td>{plan.product || t("income.plans.unattributed")}</td>
              )}
              <td>
                {plan.planName || t("income.plans.unattributed")}
                {planPrice(plan) && (
                  <span className="table-card__subtitle">
                    {" "}
                    {planPrice(plan)}
                  </span>
                )}
              </td>
              <td>{money(plan.revenueInPeriod)}</td>
              <td>{plan.share}%</td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};

export default TopPlansTable;
